import { RestoreFromTrashOutlined } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import React from "react";
import Iconify from "../Icons/Iconify";
import PermissionRestrictedComponent from "../PermissionRestrictedComponent";

interface CustomButton {
  label: string;
  icon: string | React.ReactElement;
  onClick: (row: any) => void;
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
  show?: boolean | ((row: any) => boolean);
  disable?: boolean | ((row: any) => boolean);
  permission?: number;
}
// Define the structure of your Actions component
interface DataTableActionsProps {
  onEdit?: () => void;
  onView?: (() => void) | null;
  onDelete?: () => void;
  onUpload?: (() => void) | null;
  onPrint?: (() => void) | null;
  onSendEmail?: (() => void) | null;
  onRestore?: () => void;
  isActive?: boolean;
  permissionUpdate?: number;
  permissionDeleteRestore?: number;
  permissionPrint?: number;
  permissionEmail?: number;
  permissionUpload?: number;
  disableButtons?: boolean;
  editDisable?: boolean;
  deleteDisable?: boolean;
  showDelete?: boolean;

  // Custom buttons
  customButtons?: CustomButton[];
  rowData?: any;
}

// Implement the Actions component
class DataTableActions extends React.Component<DataTableActionsProps> {
  render() {
    const {
      onEdit,
      onView,
      onDelete,
      onPrint,
      onUpload,
      onSendEmail,
      isActive,
      onRestore,
      permissionUpdate,
      permissionDeleteRestore,
      permissionPrint,
      permissionEmail,
      permissionUpload,
      disableButtons,
      editDisable,
      deleteDisable,

      showDelete = true,

      customButtons = [],
      rowData,
    } = this.props;

    const renderCustomButtons = () => {
      return customButtons.map((button, index) => {
        const shouldShow =
          typeof button.show === "function"
            ? button.show(rowData)
            : button.show !== false;

        if (!shouldShow) return null;

        const isDisabled =
          typeof button.disable === "function"
            ? button.disable(rowData)
            : !!button.disable;

        const ButtonContent = (
          <IconButton
            key={`custom-btn-${index}`}
            onClick={() => button.onClick(rowData)}
            aria-label={button.label}
            size="small"
            color={button.color || "secondary"}
            disabled={isDisabled}
            title={button.label}
          >
            {typeof button.icon === "string" ? (
              <Iconify icon={button.icon} />
            ) : (
              button.icon
            )}
          </IconButton>
        );

        if (button.permission) {
          return (
            <PermissionRestrictedComponent
              key={`custom-btn-${index}`}
              permission={button.permission}
            >
              {ButtonContent}
            </PermissionRestrictedComponent>
          );
        }

        return ButtonContent;
      });
    };

    return (
      <>
        {isActive !== false ? (
          <>
            {onEdit && (
              <PermissionRestrictedComponent
                permission={permissionUpdate || null}
              >
                <IconButton
                  onClick={onEdit}
                  aria-label="Edit"
                  size="small"
                  color="secondary"
                  disabled={!!editDisable}
                >
                  <Iconify icon={"fa-regular:edit"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}

            {onView && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onView}
                  aria-label="View"
                  size="small"
                  color="primary"
                >
                  <Iconify icon={"iconamoon:eye-light"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}

            {renderCustomButtons()}

            {onPrint && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onPrint}
                  aria-label="Print"
                  size="small"
                  color="secondary"
                >
                  <Iconify icon={"mdi:printer-outline"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onSendEmail && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onSendEmail}
                  aria-label="email"
                  size="small"
                  color="secondary"
                  sx={{
                    color: (theme) => `${theme.palette.primary} !important`,
                  }}
                >
                  <Iconify icon={"clarity:email-line"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onUpload && (
              <PermissionRestrictedComponent permission={permissionUpdate || 0}>
                <IconButton
                  onClick={onUpload}
                  aria-label="image"
                  size="small"
                  color="secondary"
                  sx={{
                    color: (theme) => `${theme.palette.primary} !important`,
                  }}
                >
                  <Iconify icon={"gridicons:cloud-upload"} />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
            {onDelete && showDelete && (
              <PermissionRestrictedComponent
                permission={permissionDeleteRestore || 0}
              >
                <IconButton
                  onClick={onDelete}
                  aria-label="Delete"
                  size="small"
                  color="error"
                  disabled={disableButtons || !!deleteDisable}
                >
                  <DeleteOutlineOutlinedIcon fontSize="small" />
                </IconButton>
              </PermissionRestrictedComponent>
            )}
          </>
        ) : (
          onRestore && (
            <PermissionRestrictedComponent
              permission={permissionDeleteRestore || 0}
            >
              <IconButton
                onClick={onRestore}
                aria-label="Restore"
                size="small"
                color="error"
              >
                <RestoreFromTrashOutlined />
              </IconButton>
            </PermissionRestrictedComponent>
          )
        )}
      </>
    );
  }
}

export default DataTableActions;
